function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLockIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "20px",
    height: "26px",
    viewBox: "0 0 20 26",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "surface1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(98.431373%,84.313725%,20.392157%)",
      fillOpacity: 1
    },
    d: "M 1.308594 10.050781 L 18.695312 10.050781 C 19.398438 10.050781 19.972656 10.621094 19.972656 11.320312 L 19.972656 24.734375 C 19.972656 25.433594 19.398438 26.003906 18.695312 26.003906 L 1.308594 26.003906 C 0.601562 26.003906 0.03125 25.433594 0.03125 24.734375 L 0.03125 11.320312 C 0.03125 10.617188 0.601562 10.050781 1.308594 10.050781 Z M 1.308594 10.050781 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(21.176471%,27.45098%,30.588235%)",
      fillOpacity: 1
    },
    d: "M 8.949219 18.886719 L 7.574219 22.472656 L 12.425781 22.472656 L 11.148438 18.832031 C 12.1875 18.296875 12.71875 17.125 12.429688 15.996094 C 12.140625 14.871094 11.109375 14.09375 9.9375 14.121094 C 8.769531 14.148438 7.773438 14.972656 7.539062 16.109375 C 7.300781 17.25 7.886719 18.398438 8.949219 18.882812 Z M 8.949219 18.886719 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(21.176471%,27.45098%,30.588235%)",
      fillOpacity: 1
    },
    d: "M 17.828125 10.050781 L 15.410156 10.050781 L 15.410156 8.058594 C 15.417969 6.5625 14.84375 5.121094 13.804688 4.039062 C 12.820312 2.988281 11.441406 2.394531 10 2.394531 C 8.558594 2.394531 7.179688 2.988281 6.195312 4.039062 C 5.15625 5.121094 4.582031 6.5625 4.589844 8.058594 L 4.589844 10.050781 L 2.171875 10.050781 L 2.171875 8.058594 C 2.167969 5.945312 2.988281 3.914062 4.457031 2.386719 C 5.890625 0.863281 7.898438 0 10 0 C 12.101562 0 14.109375 0.863281 15.542969 2.386719 C 17.015625 3.914062 17.832031 5.945312 17.828125 8.058594 Z M 17.828125 10.050781 "
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLockIcon);
export default __webpack_public_path__ + "static/media/lockIcon.edf59c90b6113edf234b2f5259783ff2.svg";
export { ForwardRef as ReactComponent };